import { computed } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { RoleState } from './role.state';
import { Role } from '../../models/rbac';

export function withRoleSelectors() {
  return signalStoreFeature(
    {
      state: type<RoleState>(),
    },
    withMethods(store => ({
      getRolesByIds(ids: string[]) {
        const roles: Role[] = [];
        ids.forEach(id => {
          roles.push(store.items()[id]);
        });
        return roles;
      },
    })),
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
    }))
  );
}
